import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid, Typography } from "@mui/material";
import pbkdf2 from "pbkdf2";

import Button from "components/NewButton";
import OTPInput from "components/OtpInput";
import "./styles.css";
import AuthHeader from "components/AuthHeader";
import { useAppDispatch } from "store/store";
import { setHashedPin } from "@slices/walletSlice";
import { showAlert } from "utils/utils";
import { Box } from "@mui/system";
import CustomizedSteppers from "components/Stepper";
import { stepsCount } from "../../../../../src/constants";

const Pin = () => {
  const [type, setType] = useState("create");
  const [pin, setPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const location = useLocation();

  const { state } = location || {};
  const { currentStep, pathName } = state || {};

  const [step, setStep] = useState(parseInt(currentStep) || 0);

  const createPin = async () => {
    try {
      if (type === "create") {
        setType("confirm");
      } else {
        if (pin !== confirmPin) {
          showAlert("Pin does not match");
        } else {
          setLoading(true);
          const hashed = pbkdf2
            .pbkdf2Sync(pin, "salt", 1, 32, "sha512")
            .toString("hex");

          dispatch(setHashedPin(hashed));
          navigate("/download-recovery-key", {
            state: { currentStep: step + 1, pathName: pathName },
          });
          setLoading(true);
        }
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleKeyPress = (e: any) => {
    const { key, keyCode } = e || {};
    if (key === "Enter" || keyCode === 13 || key === "Tab" || keyCode === 9) {
      e.preventDefault(); // Prevent the default behavior of the Tab key
      createPin();
    }
  };

  const totalSteps = stepsCount[pathName] || 3;
  return (
    <div className="create-account-container">
      <Grid container spacing={2}>
        <Grid item xs={8} className="auth-header-with-steps">
          <AuthHeader />
        </Grid>
        <Grid
          item
          xs={16}
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Box
            className="auth-header-steps"
            width={"50%"}
            style={{
              position: "absolute",
              top: "54px",
            }}
          >
            <CustomizedSteppers
              step={step}
              steps={new Array(totalSteps).fill("")}
              changeStep={setStep}
            />
          </Box>
        </Grid>
      </Grid>
      <div className="create-account-box">
        <Typography
          variant="h2"
          sx={{
            margin: "30px 0px 30px 0px",

            fontWeight: "700",
          }}
        >
          {type === "create" ? "Create" : "Confirm"} your pin
        </Typography>

        <div>
          {type === "create" ? (
            <OTPInput otp={pin} onChange={setPin} onKeyPress={handleKeyPress} />
          ) : (
            <OTPInput
              otp={confirmPin}
              onChange={setConfirmPin}
              onKeyPress={handleKeyPress}
            />
          )}

          <Button
            onClick={createPin}
            title="Continue"
            disabled={!pin && !confirmPin}
          />
        </div>
      </div>
    </div>
  );
};

export default Pin;
